import { useQuery } from 'react-query';
import {Booking, User} from 'egnahem-api';
import { egnahemApi } from './apiConfig';

const getAllBookings = (sku: string): Promise<Array<Booking>> => {
  return egnahemApi.getAllBookings(sku);
};

export const useAllBookings = (sku: string) => {
  return useQuery<Array<Booking>, Error>({
    refetchInterval: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryKey: ['allBookings'],
    queryFn: () => getAllBookings(sku),
    placeholderData: undefined
  });
};
